import React from "react";
import classNames from "classnames/bind";
import styles from "./index.module.css";
import Typography from "@mui/material/Typography";
import { planList } from "../../constant";
import PressToNext from "../../../../components/PressToNext";
import { useHistory } from "react-router";
const cx = classNames.bind(styles);

const StockPage = (props) => {
  const history = useHistory();
  const { referList } = planList[10];
  return (
    <div className={cx("stock-page-wrap")}>
      <div className={cx("stock-page-content")}>
        <section className={cx("intro")}>
          <h2>包裝你們團隊的一切資訊</h2>
          <Typography variant="h8">
            最後，要將自己的企劃呈現在投資人面前，還需要好好的包裝自己的公司團隊以及點子內容。
            <br />
            這邊跟著我們一起，一步一步做出可以拿得出手的募資企畫吧～
          </Typography>
        </section>

        <section className={cx("block1")}>
          <div className={cx("content")}>
            <section className={cx("left")}>
              <h3>設計公司logo</h3>
              <p>
                請設計出一個符合你們品牌的logo以及廣告slogan，讓你的投資人能夠在3秒內記住你們!
              </p>
            </section>
            <section className={cx("right")}>
              <div className={cx("card")}>
                <a style={{ color: "#ffffff" }} href={referList[0].link}>
                  Logodust
                </a>
              </div>
              <div className={cx("card")}>
                <a style={{ color: "#ffffff" }} href={referList[1].link}>
                  Fiverr
                </a>
              </div>
              <div className={cx("card")}>
                <a style={{ color: "#ffffff" }} href={referList[2].link}>
                  99design
                </a>
              </div>
            </section>
          </div>
        </section>

        <section className={cx("block2")}>
          <div className={cx("content")}>
            <section className={cx("left")}>
              <h3>團隊成員名片設計</h3>
              <p>
                請幫團隊成員設計出簡約易讀的名片，方便在募資時與投資正式的介紹自己喔!
              </p>
            </section>
            <section className={cx("right")}>
              <div className={cx("card")}>
                <a style={{ color: "#959595" }} href={referList[3].link}>
                  Canva
                </a>
              </div>
              <div className={cx("card")}>
                <a style={{ color: "#959595" }} href={referList[1].link}>
                  Fiverr
                </a>
              </div>
              <div className={cx("card")}>
                <a style={{ color: "#959595" }} href={referList[4].link}>
                  Pinterest
                </a>
              </div>
            </section>
          </div>
        </section>

        <section className={cx("block1")}>
          <div className={cx("content")}>
            <section className={cx("left")}>
              <h3>海報設計</h3>
              <p>
                公司海報可以靜態的宣傳公司形象與理念，甚至是讓投資人快速簡單的看到你們的產品！
              </p>
            </section>
            <section className={cx("right")}>
              <div className={cx("card")}>
                <a style={{ color: "#ffffff" }} href={referList[3].link}>
                  Canva
                </a>
              </div>
              <div className={cx("card")}>
                <a style={{ color: "#ffffff" }} href={referList[5].link}>
                  Behance
                </a>
              </div>
              <div className={cx("card")}>
                <a style={{ color: "#ffffff" }} href={referList[6].link}>
                  Venngage
                </a>
              </div>
            </section>
          </div>
        </section>

        <section className={cx("block2")}>
          <div className={cx("content")}>
            <section className={cx("left")}>
              <h3>廣告宣傳片拍攝</h3>
              <p>
                拍出最屬於你們團隊的專業廣告片！吸睛的廣告片往往更能博得偷資人的眼球喔～
              </p>
            </section>
            <section className={cx("right")}>
              <div className={cx("card")}>
                <a style={{ color: "#959595" }} href={referList[3].link}>
                  Canva
                </a>
              </div>
              <div className={cx("card1")}>
                <a style={{ color: "#959595" }} href={referList[7].link}>
                  Adobe Premiere
                </a>
              </div>
              <div className={cx("card")}>
                <a style={{ color: "#959595" }} href={referList[4].link}>
                  Pinterest
                </a>
              </div>
            </section>
          </div>
        </section>

        <section className={cx("block1")}>
          <div className={cx("content")}>
            <section className={cx("left")}>
              <h3>公司網站設計</h3>
              <p>
                最後，設計出你們的公司網頁，內容包含透過創業沙盤所做的商業計劃書、海報、宣傳片等。
                透過一個網站連結，讓投資者發現你們驚為天人的創業點子！
              </p>
            </section>
            <section className={cx("right")}>
              <div className={cx("card1")}>
                <a style={{ color: "#ffffff" }} href={referList[8].link}>
                  Google
                  <br />
                  協作平台
                </a>
              </div>
              <div className={cx("card")}>
                <a style={{ color: "#ffffff" }} href={referList[9].link}>
                  Ｗix
                </a>
              </div>
              <div className={cx("card")}>
                <a style={{ color: "#ffffff" }} href={referList[10].link}>
                  Wordpress
                </a>
              </div>
            </section>
          </div>
        </section>
        <PressToNext
          name="開始你的計劃"
          pressToNextPage={() => history.push("./Milestone/MilestoneDetail/10")}
        />
      </div>
    </div>
  );
};

export default StockPage;
